import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Camera } from 'lucide-react';
import { StatusBadge } from '../StatusBadge';

export function ClientShootsSection({ clientId, productions }) {
  const navigate = useNavigate();

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-xl font-serif font-bold text-foreground flex items-center gap-2">
          <Camera className="w-5 h-5" />
          Shoots
        </h2>
        <button
          onClick={() => navigate(`/productions/new?client=${clientId}`)}
          className="text-primary hover:text-primary/80 text-sm flex items-center gap-1"
          data-testid="add-shoot-button"
        >
          <Plus className="w-4 h-4" />
          New
        </button>
      </div>
      {productions.length === 0 ? (
        <div className="bg-surface border border-border rounded-lg p-4 text-center text-text-muted text-sm">
          No shoots yet
        </div>
      ) : (
        <div className="space-y-2">
          {productions.map((prod) => (
            <div
              key={prod.id}
              className="bg-surface border border-border rounded-lg p-3"
              data-testid={`production-${prod.id}`}
            >
              <div className="flex items-start justify-between mb-1">
                <h3 className="font-medium text-foreground">{prod.title}</h3>
                <StatusBadge status={prod.status} />
              </div>
              <p className="text-sm text-text-secondary">{prod.location || 'Location TBD'}</p>
              {prod.shoot_date && (
                <p className="text-xs text-text-muted mt-1">{prod.shoot_date}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
